import { render } from "./TextNoWordBreak.vue?vue&type=template&id=3c475fcc"
import script from "./TextNoWordBreak.vue?vue&type=script&lang=js"
export * from "./TextNoWordBreak.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__